import React from 'react';
import { cn } from '@/lib/utils';

type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
};

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon, action, className }) => {
  return (
    <div className={cn("w-full flex flex-col items-center justify-center text-center p-6 border rounded-md bg-muted/30", className)}>
      {icon && <div className="mb-3 text-muted-foreground">{icon}</div>}
      <h3 className="text-base font-medium mb-1">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mb-3">{description}</p>}
      {action}
    </div>
  );
};


